import EntityMapper from '../EntityMapper';

import PositionMapper, {
  PositionData,
} from '../../../value_objects/mappers/PositionMapper';

import CharacterUpdateCommand from '../../../../domain/entities/commands/CharacterUpdateCommand';
import ResourcesSet from '../../../../domain/entities/resources/ResourcesSet';

import CharacterCommandOptionsMapper, {
  CharacterCommandOptionsData,
} from '../../../value_objects/mappers/command_options/CharacterCommandOptionsMapper';

export interface CharacterUpdateCommandData {
  id: number;
  scene_id: number;
  type: 'character_update';
  character_id: number;
  position: PositionData;
  face: string;
  mark_id: number | null;
  options?: CharacterCommandOptionsData;
}

export default class CharacterUpdateCommandMapper
  implements EntityMapper<CharacterUpdateCommandData, CharacterUpdateCommand>
{
  private positionMapper: PositionMapper;
  private characterCommandOptionsMapper: CharacterCommandOptionsMapper;

  constructor(private resourcesSet: ResourcesSet) {
    this.positionMapper = new PositionMapper();
    this.characterCommandOptionsMapper = new CharacterCommandOptionsMapper();
  }

  public map(obj: CharacterUpdateCommandData): CharacterUpdateCommand {
    const position = this.positionMapper.map(obj.position);
    const options = this.characterCommandOptionsMapper.map(obj.options || {});
    return new CharacterUpdateCommand(
      obj.id,
      obj.scene_id,
      this.resourcesSet.getCharacterResource(obj.character_id),
      position,
      obj.face,
      obj.mark_id ? this.resourcesSet.getMarkResource(obj.mark_id) : null,
      options,
    );
  }
}
